var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 8,
    viewBox: "0 0 44 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8633 4.35355C44.0586 4.15829 44.0586 3.84171 43.8633 3.64645L40.6813 0.464466C40.4861 0.269204 40.1695 0.269204 39.9742 0.464466C39.779 0.659728 39.779 0.976311 39.9742 1.17157L42.8027 4L39.9742 6.82843C39.779 7.02369 39.779 7.34027 39.9742 7.53553C40.1695 7.7308 40.4861 7.7308 40.6813 7.53553L43.8633 4.35355ZM0.509766 4.5H43.5098V3.5H0.509766V4.5Z",
    fill: "#FF5234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cca231cd5749305ea4b0876de5b04ec0.svg";
export { ForwardRef as ReactComponent };